// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateArgentineCbu(cbu: string): ?UserInputValidationError {
  if (!cbu) {
    return { id: 'empty'};
  } else if (!/^\d+$/.test(cbu)) {
    return { id: 'invalid-cbu-format' };
  } else if (cbu.length < 22) {
    return { id: 'invalid-cbu' };
  }
}
